import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/UnderMaintenanceIllustration.tsx
const UnderMaintenanceIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "under-maintenance.svg",
		alt: t("illustration.imageAlt.maintenance")
	});
};

//#endregion
export { UnderMaintenanceIllustration };